import bulkUploadActions from "./action";

const initialState = {
    backofficeTokenDetails: null,
};

const bulkUploadReducer = (state = initialState, action) => {
    switch (action.type) {
       
        default:
            return state;
    }
};

export default bulkUploadReducer;

